import { render, staticRenderFns } from "./currentEvents.vue?vue&type=template&id=6d36fd6d&"
import script from "./currentEvents.vue?vue&type=script&lang=js&"
export * from "./currentEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports